import { useEffect, useState } from "react";

const FAQViewModal = ({ open, onClose, details }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (open) {
      setShow(true);
    } else {
      setTimeout(() => setShow(false), 200);
    }
  }, [open]);

  // ESC close
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };

    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (!show || !details) return null;

  return (
    <div
      onClick={onClose}   // 👈 backdrop click close
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 transition-opacity duration-200 ${
        open ? "opacity-100" : "opacity-0"
      } bg-black/50`}
    >
      
      <div
        onClick={(e) => e.stopPropagation()} // 👈 prevent close on modal click
        className={`w-full max-w-3xl bg-white dark:bg-slate-900 rounded-xl shadow-xl overflow-hidden transform transition-all duration-200 ${
          open ? "scale-100 opacity-100" : "scale-95 opacity-0"
        }`}
      >

        {/* HEADER */}
        <div className="flex items-center justify-between px-5 py-3 bg-slate-900 text-white">
          <div>
            <h2 className="text-base font-semibold">
              {details.section_name}
            </h2>
            <p className="text-xs text-gray-300">
              FAQ Details
            </p>
          </div>

          <button
            onClick={onClose}
            className="text-white text-lg"
          >
            ✕
          </button>
        </div>

        {/* BODY */}
        <div className="p-4 space-y-3 max-h-[70vh] overflow-y-auto">

          {/* INFO */}
          <div className="flex items-center justify-between text-xs px-3 py-2 bg-gray-50 dark:bg-slate-800 rounded-md">
            <span className="text-gray-500">
              Total FAQs: {details.faqs?.length || 0}
            </span>

            <span
              className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                details.status
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-700"
              }`}
            >
              {details.status ? "Active" : "Inactive"}
            </span>
          </div>

          {/* ACCORDION */}
          <div className="space-y-2">
            {details.faqs?.map((faq, index) => (
              <div
                key={faq.id || index}
                className="border border-gray-200 dark:border-slate-700 rounded-md overflow-hidden"
              >
                
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex items-center justify-between px-3 py-2 text-left bg-gray-50 dark:bg-slate-800 hover:bg-gray-100 dark:hover:bg-slate-700"
                >
                  <span className="text-sm font-medium">
                    {faq.question}
                  </span>

                  <span className="text-xs text-gray-500">
                    {activeIndex === index ? "−" : "+"}
                  </span>
                </button>

                <div
                  className={`px-3 text-xs text-gray-600 dark:text-gray-300 bg-white dark:bg-slate-900 border-t border-gray-200 dark:border-slate-700 overflow-hidden transition-all duration-200 ${
                    activeIndex === index
                      ? "max-h-40 py-2 opacity-100"
                      : "max-h-0 py-0 opacity-0"
                  }`}
                >
                  {faq.answer}
                </div>

              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default FAQViewModal;